import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["allowedMessageChannelIds", "isSelected", "selectChannel"];
import UIButton from 'UIComponents/button/UIButton';
import UIList from 'UIComponents/list/UIList';
import { ChannelLabel } from '../../../capability-editor/public/components';
import { CallingTab } from './CallingTab';
import { useAsyncGenericChannelsWithCapabilities } from 'composer-data/channel-capabilities/public/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ChannelDropdownOption = ({
  selectChannel,
  isSelected,
  genericChannelId
}) => {
  const {
    loading,
    error
  } = useAsyncGenericChannelsWithCapabilities();
  const disabled = Boolean(loading || error);
  return /*#__PURE__*/_jsx(UIButton, {
    use: "primary-white",
    disabled: disabled,
    onClick: selectChannel,
    value: genericChannelId,
    "data-test-id": "channel-switch-dropdown-option",
    "data-channel-id": genericChannelId,
    "is-selected": `${isSelected}`,
    children: /*#__PURE__*/_jsx(ChannelLabel, {
      genericChannelId: genericChannelId
    })
  });
};
ChannelDropdownOption.displayName = 'ChannelDropdownOption';
function hasCalling(props) {
  return props.hasCalling;
}
export const ChannelDropdownOptions = _ref => {
  let {
      allowedMessageChannelIds,
      isSelected,
      selectChannel
    } = _ref,
    callingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const shouldIncludeCalling = hasCalling(callingProps);
  return /*#__PURE__*/_jsxs(UIList, {
    children: [shouldIncludeCalling ? /*#__PURE__*/_jsx(CallingTab, Object.assign({}, callingProps)) : null, allowedMessageChannelIds.map(channelId => {
      return /*#__PURE__*/_jsx(ChannelDropdownOption, {
        genericChannelId: channelId,
        isSelected: isSelected,
        selectChannel: selectChannel
      }, channelId);
    })]
  });
};
ChannelDropdownOptions.displayName = 'ChannelDropdownOptions';